<template>
  <div v-if="operationLog.target_type === 'Customer'">
    <span v-if="operationLog.event === 'create'">
      创建 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'pick'">
      领取 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'release'">
      释放 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'assign' && operationLog.data.user_screen_name">
      转接 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link> 给 <bean-link keepNode :to="{ name: 'users.show', params: { id: operationLog.data.user_id } }">{{operationLog.data.user_screen_name}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'assign' && !operationLog.data.user_screen_name">
      转接 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'apply_assign' && operationLog.data.assign_to_user_screen_name">
      申请转接 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link> 给 <bean-link keepNode :to="{ name: 'users.show', params: { id: operationLog.data.assign_to_user_id } }">{{operationLog.data.assign_to_user_screen_name}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'apply_assign' && !operationLog.data.assign_to_user_screen_name">
      申请转接 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'cancel_apply_assign'">
      取消转接 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'approve_assign'">
      同意转接 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'reject_assign'">
      拒绝转接 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
    <span v-else-if="operationLog.event === 'business_executive_release'">
      释放 <bean-link keepNode :to="{ name: 'customers.show', params: { id: operationLog.target_id } }">{{displayText(operationLog.target)}}</bean-link>
    </span>
  </div>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { displayText } from '@/custom_models_extend';

  @Component
  export default class OperationLogDetail extends Vue {
    @Prop({ type: Object, default: () => {} }) operationLog;

    displayText = displayText;
  }
</script>

<style>

</style>
